export class MathUtil {
    public static roundDownToNearestMultiple(amount: number, denomination: number): number {
        return Math.floor(amount / denomination) * denomination;
    }

    public static roundUpToNearestMultiple(amount: number, denomination: number): number {
        return Math.ceil(amount / denomination) * denomination;
    }
}